// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__8Ger8","fileBtn":"File_fileBtn__1FIYr","closeBtn":"File_closeBtn__1HGBx","fileSelected":"File_fileSelected__3-eG2","disabled":"File_disabled__3LlhH"};